<template>
  <CongrModal :visible="visible" @close="handleClose">
    <div class="winContent">
      <div class="title">恭喜你获得</div>
      <div class="awardName">
        {{ awardData.name }}
      </div>
      <div v-if="awards.length === 1" class="singleAwardImg">
        <Award :awardData="awards[0]" />
      </div>
      <div class="note">以上奖励已放入【奖励记录】</div>
      <div class="okBtn" @click="handleClickOk">我知道了</div>
    </div>
  </CongrModal>
</template>

<script>
import CongrModal from '@/components/templates/common/CongrModal';
import Award from '@/components/templates/common/awardItem/Award';
export default {
  components: { CongrModal, Award },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    awardData: {
      type: Object,
      required: true
    }
  },
  computed: {
    awards() {
      return this.awardData.awards || [];
    }
  },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        // 埋点
        this.reportExpo();
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleClickOk() {
      this.$emit('close');
    },
    handleGoAddressPage() {
      this.$emit('close');
      this.$router.push('/contact');
    },
    reportExpo() {
      const AwardTypeNameMap = {
        MEMBER: '会员奖励弹窗',
        OIL_COUPON: '加油卡奖励弹窗',
        RIGHT_CARD: '权益卡奖励弹窗',
        ENTITY: '实物奖弹窗',
        COUPON: '优惠券弹窗',
        RED_PACKET: '红包弹窗',
        CURRENCY: '现金奖弹窗'
      };
      if (
        this.awardData &&
        this.awardData.awards &&
        this.awardData.awards.length
      ) {
        let awardTypeName = '无';
        if (this.awardData.awards.length === 1) {
          const award = this.awardData.awards[0];
          awardTypeName =
            AwardTypeNameMap[award.rewardType] || award.rewardType;
        } else {
          awardTypeName = `奖品弹窗${this.awardData.awards.length}`;
        }
        this.visitLog('', '', {
          actEventType: 'activity_topic_popup_expo',
          module_name: awardTypeName
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.winContent {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 40px;
    color: #333;
  }

  .awardName {
    margin: 20px auto 30px;
    width: 478px;
    font-size: 40px;
    color: #ff6600;
  }

  .singleAwardImg {
    width: 280px;
    height: 280px;
    font-size: 50px;
  }

  .note {
    margin-top: 50px;
    font-size: 28px;
    color: #a0a0a0;
  }

  .okBtn {
    margin-top: 18px;
    margin-bottom: 50px;
    width: 450px;
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    background: linear-gradient(to top, #ff7e00 0%, #ff9600 39%, #ffb80f 99%);
    border-radius: 44px;
    font-size: 40px;
    color: #fff;
  }
}
</style>
